class LocationPathHelper {
  static stringifyParams(params) {
    return Object.keys(params)
      .map((key) => {
        const value = params[key]
        if (Array.isArray(value)) {
          const result = []
          for (const arrayValue of value) {
            result.push(
              `${encodeURIComponent(`${key}[]`)}=${encodeURIComponent(
                arrayValue
              )}`
            )
          }
          return result.join('&')
        }
        return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      })
      .join('&')
  }

  static getPathName() {
    if (!window) {
      return false
    }
    return window.location.pathname
  }

  static getPathNameAsArray() {
    const pathName = LocationPathHelper.getPathName()
    return pathName.slice(1).split('/')
  }

  static getWindowLocationSearch() {
    return window.location.search
  }

  static get(name) {
    // Grabs location.search and executes the regex expression
    // which grabs the URL parameter value of `name`.
    return (
      decodeURIComponent(
        (new RegExp(`[?|&]${name}=([^&;]+?)(&|#|;|$)`).exec(
          this.getWindowLocationSearch()
        ) || [null, ''])[1].replace(/\+/g, '%20')
      ) || null
    )
  }

  static removeQueryParams() {
    window.history.replaceState(null, null, window.location.href.split('?')[0])
  }
}

export default LocationPathHelper
